// Docs shell — Fieldbook. Shared sticky FieldHeader + sidebar + reading column.
import { ReactNode } from "react";
import DocsSidebar from "./DocsSidebar";
import FieldHeader from "@/components/field/FieldHeader";
import FieldFooter from "@/components/field/FieldFooter";
import "@/styles/design-tokens.css";
import "./docs.css";

export default function DocsShell({ children }: { children: ReactNode }) {
  return (
    <div className="ffly ffly--public docs-shell">
      <FieldHeader active="docs" sticky wide />
      <div className="docs-body">
        <aside className="docs-side">
          <DocsSidebar />
        </aside>
        <main className="docs-main">
          <div className="docs-content">{children}</div>
          <FieldFooter variant="compact" />
        </main>
      </div>
    </div>
  );
}
